import React from "react";

const ConnectionSummaryCard = ({
    icon: Icon,
    title,
    value,
    isLoading,
}) => (
    <div className="rounded-2xl border border-slate-200 bg-white p-3 shadow-sm sm:p-4">
        <div className="flex items-center gap-3">
            {Icon && (
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-indigo-50 text-indigo-600 ring-1 ring-indigo-100">
                    <Icon size={20} aria-hidden="true" />
                </div>
            )}
            <div className="min-w-0">
                <p className="text-sm font-medium text-slate-600">{title}</p>
                {isLoading ? (
                    <div className="mt-2 h-5 w-24 animate-pulse rounded bg-slate-100" />
                ) : (
                    <p
                        className="mt-1 truncate text-xl font-bold text-slate-900"
                        title={String(value)}
                    >
                        {value}
                    </p>
                )}
            </div>
        </div>
    </div>
);

export default ConnectionSummaryCard;
